import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BodyContainer,
  Title,
  OptionsContainer,
  WhiteLetter,
  OrangeLetter,
  ContainerLeft,
  ContainerRight,
  TextInterest,
  Content,
  AnimationLoading,
  ContainerLinks,
  ContainerPagination,
  ContainerButton,
} from "./styles";
import OptionCard from "../../components/option-card/index";
import IconFamily from "../Icons/PillarsIcons/IconFamily";
import { RoutesNames } from "../utils/routes";
import IconJob from "../Icons/PillarsIcons/IconJob";
import IconHealth from "../Icons/PillarsIcons/IconHealth";
import IconServicesGuide from "../Icons/PillarsIcons/IconServicesGuide";
import IconLGTBIQ from "../Icons/PillarsIcons/IconLGTBIQ+";
import IconLegalAndDocumental from "../Icons/PillarsIcons/IconLegalAndDocumental";
import IconFinancial from "../Icons/PillarsIcons/IconFinancial";
import IconSecurity from "../Icons/PillarsIcons/IconSecurity";
import { useLazyQuery } from "@apollo/client";
import { GET_THEMES_INTEREST } from "../../Graphql/queries/queryGetThemesInterest";
import { useToastError } from "../../Hooks/useToastError";
import IconPreview from "../Icons/IconPreview";
import IconNext from "../Icons/IconNext";
import CardRedirectionLink from "../cards/CardRedirectionLink";

const Home = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  const [getThemes, { error, data, loading }] = useLazyQuery(GET_THEMES_INTEREST);

  useToastError(error);

  useEffect(() => {
    getThemes({
      variables: {
        page: page,
        pageSize: 3,
      },
    });
  }, [page, getThemes]);

  // const handleDirectory = () => {
  //   router.push(RoutesNames.directoryMunicipalities)
  // }

  const handlePreviewPage = () => {
    setPage(page - 1);
  };

  const handleNextPage = () => {
    setPage(page + 1);
  };
  const handleForm = (redirect) => {
    navigate(redirect);
  };

  return (
    <BodyContainer>
      <ContainerLeft>
        <Title>
          {" "}
          BIENVENIDO <WhiteLetter>AL PORTAL </WhiteLetter> <OrangeLetter>INTEGRACIÓN </OrangeLetter> MIGRANTE
        </Title>
        <OptionsContainer>
          <OptionCard title="Familia" description="Accede a los servicios" icon={<IconFamily />} />
          <OptionCard
            title="Salud"
            description="Accede a los servicios"
            imageSrc="/img/salud.png"
            icon={<IconHealth />}
            onClick={() => handleForm(RoutesNames.optionsHealth)}
          />
          <OptionCard
            title="Empleo"
            description="Accede a los servicios"
            imageSrc="/img/empleo.png"
            icon={<IconJob />}
          />
          <OptionCard
            title="Guía de servicios"
            description="Accede a los servicios"
            imageSrc="/img/guia.png"
            icon={<IconServicesGuide />}
            onClick={() => handleForm(RoutesNames.serviceGuide)}
          />
          <OptionCard
            title="LGTBIQ+"
            description="Accede a los servicios"
            imageSrc="/img/bandera.png"
            icon={<IconLGTBIQ />}
          />
          <OptionCard
            title="Legal y documental"
            description="Accede a los servicios"
            imageSrc="/img/legal.png"
            icon={<IconLegalAndDocumental />}
            onClick={() => handleForm(RoutesNames.OptionsLegalAndDocumental)}
          />
          <OptionCard
            title="Financiera"
            description="Accede a los servicios"
            imageSrc="/img/financiera.png"
            icon={<IconFinancial />}
          />
          <OptionCard
            title="Seguridad"
            description="Accede a los servicios"
            imageSrc="/img/financiera.png"
            icon={<IconSecurity />}
          />
        </OptionsContainer>
      </ContainerLeft>
      <ContainerRight>
        <TextInterest>Temas de interés...</TextInterest>
        {loading ? (
          <Content>
            <AnimationLoading />
          </Content>
        ) : (
          <>
            <ContainerLinks>
              {data?.getThemesOfInterest.data.map((item) => (
                <CardRedirectionLink item={item} key={item.id} />
              ))}
            </ContainerLinks>
            <ContainerPagination>
              <ContainerButton style={page === 1 ? { visibility: "hidden" } : null} onClick={handlePreviewPage}>
                <IconPreview />
                Anterior
              </ContainerButton>
              <div>
                {page} de{" "}
                {data?.getThemesOfInterest.meta.pageCount === 0
                  ? data?.getThemesOfInterest.meta.pageCount + 1
                  : data?.getThemesOfInterest.meta.pageCount}
              </div>
              <ContainerButton
                style={
                  data?.getThemesOfInterest.meta.pageCount === 0 || page === data?.getThemesOfInterest.meta.pageCount
                    ? { visibility: "hidden" }
                    : null
                }
                onClick={handleNextPage}
              >
                Siguiente
                <IconNext />
              </ContainerButton>
            </ContainerPagination>
          </>
        )}
      </ContainerRight>
    </BodyContainer>
  );
};

export default Home;
